import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5f644adf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5f644adf&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f644adf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f644adf')) {
      api.createRecord('5f644adf', component.options)
    } else {
      api.reload('5f644adf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5f644adf&scoped=true", function () {
      api.rerender('5f644adf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P5_Activitys/NinePointNinetyNine/index.vue"
export default component.exports